import React from "react";
import { EditLoadioStoreFeaturedSectionContentModalTemplate } from "themes/administration/loadio/components";

function EditLoadioStoreFeaturedSectionContentModal(props) {
    return <EditLoadioStoreFeaturedSectionContentModalTemplate {...props} />;
}

export default EditLoadioStoreFeaturedSectionContentModal;
